import { render, staticRenderFns } from "./UserZoneSelf.vue?vue&type=template&id=31d958c6&lang=html&"
import script from "./UserZoneSelf.vue?vue&type=script&lang=js&"
export * from "./UserZoneSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports